
/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/
/* eslint-disable max-len */
import React from 'react';
import Layout from '../../../../components/Layout';
import ServicesLayout from '../../../../components/ServicesLayout';
import EditAvailableService from './EditAvailableService';

import { isAdminUser } from '../../../../lib/utils';

/* CHANGE THIS TITLE */
const title = 'DUMMY TITLE';

export default {

  path: '/:id',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    const { params } = ctx;
    if (!isAdmin) {
      return { redirect: '/' };
    }
    return {
      title,
      chunk: 'EditAvailableService',
      component: <ServicesLayout isAdmin><EditAvailableService title={title} params={params} /> </ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/admin/available_services/edit_availableservice/index.js